import { can } from '@abastece/shared';
import { PERMISOS_DE_PANTALLA } from '../lib/permisos.js';
import { useT } from '../i18n/index.js';
import { Pagina, Vacio } from './Pagina.js';

/**
 * In place of a screen somebody may not use (`lib/permisos.ts`). Saying whose it is when it is
 * only ever the owner's, since that tells a cashier who to ask.
 */
export function SinPermiso({ ruta }: { ruta: string }) {
  const t = useT();
  const permisos = PERMISOS_DE_PANTALLA[ruta] ?? [];
  const delDueno = permisos.every((p) => !can('cajero', p) && !can('repartidor', p));
  return (
    <Pagina titulo={t('comun.sinAcceso')}>
      <Vacio mensaje={t(delDueno ? 'comun.esDelDueno' : 'comun.sinPermiso')} icono="bloquear" />
    </Pagina>
  );
}
